export const processingSteps = {
  label: "Étapes de travail",
  processingStepsFor: "Étapes de travail pour {name}",
  noProcessingSteps: "Aucune étape subséquente déterminée",
  configureProcessingSteps: "Configurer la pièce",
  quantity: "Quantité",
  // TODO: add translation
  notWorkingDemoVersion: "(nicht funktionale Demoversion)",
  inputLabels: {
  },
  actionLabels: {
    saveConfiguration: "Sauvegarder",
    addStep: "Ajouter",
  },
};
